import type { FieldPath, FieldValues } from 'react-hook-form';

export const prefixFieldNameIfPrefixExists = <T extends FieldValues>(
  formFieldName: string,
  fieldPrefix?: string,
): FieldPath<T> => {
  return `${fieldPrefix ? `${fieldPrefix}.` : ''}${formFieldName}` as FieldPath<T>;
};

export const parseInputValueAsNumber = (value?: string | number) => {
  if (!value) return undefined;
  return +value;
};
